import React from 'react';
import { RPDF } from '../react-pdf';
import { LmReportLogo } from './svg/LmReportLogo';
import { DateFormats, localFormat } from '../../../helpers/date-helpers';
import { ReportColors } from '../report-colors';
import { useScopedTranslation } from 'src/application/localisation/useScopedTranslation';

export const ReportPagination: React.FC = () => {
  const { t } = useScopedTranslation('Reports.Records');

  const localStyles = RPDF.StyleSheet.create({
    paginationPosition: {
      position: 'absolute',
      bottom: -60,
      height: 36,
      width: '100%',
    },
    paginationContainer: {
      position: 'relative',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
    },

    paginationPagesContainer: {
      position: 'absolute',
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    paginationPagesText: {
      color: ReportColors.plain,
      fontSize: 10,
      fontFamily: 'Montserrat',
      fontStyle: 'normal',
      fontWeight: 'normal',
    },
  });

  return (
    <RPDF.View fixed={true} style={localStyles.paginationPosition}>
      <RPDF.View style={localStyles.paginationContainer}>
        <LmReportLogo />
        <RPDF.View style={localStyles.paginationPagesContainer}>
          <RPDF.Text
            fixed={true}
            render={({ pageNumber, totalPages }) => `${pageNumber} / ${totalPages}`}
            style={localStyles.paginationPagesText}
          />
        </RPDF.View>
        <RPDF.Text style={RPDF.typography.text8}>
          {t('ExportedAt', { date: localFormat(new Date(), DateFormats.dateTime) })}
        </RPDF.Text>
      </RPDF.View>
    </RPDF.View>
  );
};
